import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { BrowserUtils } from '@azure/msal-browser';
import { HomeComponent } from './home/home.component';
import { FailedComponent } from './failed/failed.component';
import { FormulariosComponent } from './formularios/formularios.component';
import { FormularioComponent } from './formulario/formulario.component';
import { FormProyectoComponent } from './form-proyecto/form-proyecto.component';
import { ConfiguracionComponent } from './configuracion/configuracion.component';
import { CrearcontrasenaComponent } from './crearcontrasena/crearcontrasena.component';
import { EditarformularioComponent } from './editarformulario/editarformulario.component';
import { RegistroComponent } from './registro/registro.component';
import { DiligenciarComponent } from './diligenciar/diligenciar.component';
import { ArchivoComponent } from './archivo/archivo.component';
import { ScaleComponent } from './scale/scale.component';
import { PppfaComponent } from './pppfa/pppfa.component';
import { ParticipantesComponent } from './participantes/participantes.component';
import { ZonaseguraComponent } from './participantes/zonasegura/zonasegura.component';

const routes: Routes = [
    { path: 'registro/:id',  component: RegistroComponent },
    { path: 'editarformulario/:id',  component: EditarformularioComponent },
    { path: 'crearcontrasena/:id', component: CrearcontrasenaComponent },
    { path: 'formularios', component: FormulariosComponent },
    { path: 'formulario', component: FormularioComponent },
    { path: 'formulario/:id', component: FormularioComponent },
    { path: 'proyecto/:id', component: FormProyectoComponent },
    { path: 'diligenciar/:id', component: DiligenciarComponent },
    { path: 'formulario/:id/:idencuesta', component: FormularioComponent },
    { path: 'archivo/:idencuesta/:nombrearchivo', component: ArchivoComponent },
    { path: 'configuracion/:idformulario/:idencuesta/:idregistro', component: ConfiguracionComponent },
    { path: 'pppfa', component: PppfaComponent },
    {
        path: 'participantes',
        component: ParticipantesComponent,
        canActivate: [MsalGuard]
    },
    {
        path: 'participantes/zonasegura',
        component: ZonaseguraComponent,
        canActivate: [MsalGuard]
    },

    {
        path: '',
        component: HomeComponent
    },
    {
        path: 'login-failed',
        component: FailedComponent
    },
    { path: 'scale', component: ScaleComponent },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        // Don't perform initial navigation in iframes or popups
        initialNavigation: !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'disabled' // Set to enabledBlocking to use Angular Universal
    })],
    exports: [RouterModule]
})
export class AppRoutingModule { }